const hasOwnProperty = (target, key) => Object.prototype.hasOwnProperty.call(target, key);

const getRuntimeConfig = () => {
  if (typeof window === 'undefined' || typeof window.__CONFIG__ !== 'object' || window.__CONFIG__ === null) {
    return {};
  }

  return window.__CONFIG__;
};

const normalizeStringValue = (value) => {
  if (value === undefined || value === null) {
    return '';
  }

  return String(value).trim();
};

const getStringConfig = (key, defaultValue = '') => {
  const runtimeConfig = getRuntimeConfig();

  if (hasOwnProperty(runtimeConfig, key)) {
    const runtimeValue = normalizeStringValue(runtimeConfig[key]);
    if (runtimeValue !== '') {
      return runtimeValue;
    }
  }

  const buildValue = normalizeStringValue(process.env[key]);
  return buildValue === '' ? defaultValue : buildValue;
};

const parseStrictBoolean = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim().toLowerCase();

  if (normalizedValue === 'true') {
    return true;
  }

  if (normalizedValue === 'false') {
    return false;
  }

  return null;
};

const getBooleanConfig = (key, defaultValue = false) => {
  const runtimeConfig = getRuntimeConfig();

  if (hasOwnProperty(runtimeConfig, key)) {
    const runtimeValue = parseStrictBoolean(runtimeConfig[key]);
    if (runtimeValue !== null) {
      return runtimeValue;
    }
  }

  const buildValue = parseStrictBoolean(process.env[key]);
  if (buildValue !== null) {
    return buildValue;
  }

  return defaultValue;
};

const googleClientId = getStringConfig('REACT_APP_GOOGLE_CLIENT_ID', '');
const googleLoginEnabled = getBooleanConfig('REACT_APP_GOOGLE_LOGIN_ENABLED', false);

export const appConfig = Object.freeze({
  googleClientId,
  googleLoginEnabled,
  isGoogleLoginConfigured: googleLoginEnabled && googleClientId !== '',
});

export const isGoogleLoginConfigured = appConfig.isGoogleLoginConfigured;
